import { GatshipNotification } from '@gat-ship/notifications'
import type { ApiResponseError } from '@gat-ship/lib/error-handling'
import { getAuth0Client } from '@gat-ship/lib/auth'

export function handleApiError(error: ApiResponseError<unknown>) {
  const status = error.apiError.status
  const title = error.getTitle()
  const description = error.getDescription()
  console.log('status', status)
  switch (status) {
    case 401:
      return new GatshipNotification({
        title: 'Unauthorized',
        description: 'You are not authorized to access this resource.',
        notificationType: 'toast'
      })
    case 404:
      return new GatshipNotification({
        title: title,
        description: description,
        notificationType: 'toast'
      })
    default:
      return new GatshipNotification({
        title: title,
        description: description,
        notificationType: 'toast'
      })
  }
}
